import { render, staticRenderFns } from "./LinksTab.vue?vue&type=template&id=33249e90"
import script from "./LinksTab.vue?vue&type=script&lang=js"
export * from "./LinksTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports